module.exports = __webpack_public_path__ + "a8dae0d0d60a73eb02f39db2b6a8da2a.svg";